$ = require 'jquery'
CalendarCardComposerView = require 'views/card-composer/calendar-card-composer-view'
CalendarMonthView = require 'views/calendar/calendar-month-view'
CalendarViewState = require 'view-models/calendar-view-state'
CalendarWeekView = require 'views/calendar/calendar-week-view'
CalendarSettingsView = require 'views/power-ups/calendar-settings-view'
Dates = require 'lib/dates'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
WindowSize = require 'lib/window-size'
templates = require 'views/internal/templates'
moment = require 'moment'

module.exports = class CalendarControllerView extends View
  className: 'calendar-wrapper'

  events:
    'click .js-week-view': 'switchToWeekViewFromMonth'
    'click .js-month-view': 'switchToMonthViewFromWeek'

    'click .js-left-arrow': 'navigatePrevious'
    'click .js-right-arrow': 'navigateNext'
    'click .js-today': 'navigateToday'

    'click .js-open-card-composer': 'openComposer'

    'click .js-calendar-settings': (e) ->
      Util.stop(e)
      @showSettings(e.currentTarget)

  initialize: ->
    @monthView = @subview(CalendarMonthView, @model)
    @weekView = @subview(CalendarWeekView, @model)

    @localState = new CalendarViewState(id: 'calendar' + @model.id)
    @localState.fetch()

    # Clear selected card so selecting the same card in calendar view fires the
    # active-card-changed event.
    @model.viewState.clearSelectedCard()

  render: (date = new Date()) ->
    toolbarDisplayDays = Dates.getDaysOfWeek(date).map (date) ->
      moment(date).format('ddd')

    @$el.html(templates.fill('calendar_toolbar', { days: toolbarDisplayDays }))

    if @localState.getMode() == CalendarWeekView::VIEWSTATE_PREF_STR
      @showView(@weekView, date)
    else
      @showView(@monthView, date)
    @

  remove: ->
    @stopSubscriptions()
    @model.viewState.clearSelectedCard()
    super

  showSettings: (elem) ->
    PopOver.toggle
      elem: elem
      view: new CalendarSettingsView({ model: @model })
      autoPosition: true

  openComposer: (e) ->
    Util.stop(e)

    $dayEl = $(e.target).closest('.day-cell, .day-column')
    date = new Date(parseInt $dayEl.attr('name'))

    composer = new CalendarCardComposerView({ model: @model.composer, @modelCache })
    composer.setDate(date)

    PopOver.show
      clientx: e.clientX
      clienty: e.clientY
      view: composer

  showView: (view, date) ->
    @currentSubView = view
    $header = @$('.calendar-header')
      .removeClass('week-view month-view')
      .addClass(@currentSubView.HEADER_CLASS_NAME)

    @$('.calendar-content').empty().append(@currentSubView.render(date).el)
    @model.viewState.clearSelectedCard()
    @localState.setMode(@currentSubView.VIEWSTATE_PREF_STR)

    @currentSubView.delegateEvents()
    @currentSubView.updateRoute()

  switchToWeekViewFromMonth: ->
    @showView(@weekView, @monthView.currentCenterWeek)
    @addedToDOM()

  switchToMonthViewFromWeek: ->
    @showView(@monthView, @weekView.currentWeek)
    @addedToDOM()

  setSubscriptions: ->
    @stopSubscriptions()

    if @currentSubView == @monthView
      @monthView.setSubscriptions()
    else
      $(WindowSize).on "windowClassChange.#{ @uniqueId() }", (args...) =>
        @weekSmallWindowResizeCheck(args...)
      @weekView.setSubscriptions()
    return

  stopSubscriptions: ->
    @weekView.stopSubscriptions()
    @monthView.stopSubscriptions()
    $(WindowSize).off(".#{ @uniqueId() }")

  delegateEvents: ->
    super
    @currentSubView?.delegateEvents()

  addedToDOM: ->
    @setSubscriptions()
    @currentSubView.addedToDOM()

  navigateToday: -> @currentSubView.navigateToday()
  navigatePrevious: -> @currentSubView.navigatePrevious()
  navigateNext: -> @currentSubView.navigateNext()

  # There is no small-window week view, so we change to month mode
  weekSmallWindowResizeCheck: (e, classes) ->
    if WindowSize.fSmall && @currentSubView == @weekView
      @switchToMonthViewFromWeek()



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-controller-view.coffee